
































































































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import Switcher from '@/components/Switcher.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import ScrollView from '@/components/ScrollView.vue'
import { FacilityModule } from '@/store/modules/facility.module'
import { EUserPermissions, IFacilityPayerGroup, IPayerType } from '@zunta/configurations'
import Api from '@/api'
import { User } from '@/classes/User'
import ModalV2 from '@/components/modals/ModalV2.vue'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import { getSelectContentLabel } from '@/utils/helpers'

@Component({
  components: {
    InputV2,
    ModalV2,
    Checkbox,
    Switcher,
    ScrollView
  },
  props: {
    payers: {
      type: Array
    },
    payersSettings: {
      type: Array
    },
    payerTypesProp: {},
    disableAllPayerPeriods: {
      type: Boolean,
      default: false
    },
    selectedFacilityProp: {}
  }
})
export default class BatchPayerTypeModal extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  user: User = Api.getUser() as User
  EUserPermissions: any = EUserPermissions
  getSelectContentLabel: Function = getSelectContentLabel

  localPayerTypes: IPayerType[] = []
  selectAll: boolean = true
  searchValue: string = ''

  get selectedFacility () {
    return this.$props.selectedFacilityProp
  }

  get payerTypes (): IPayerType[] {
    return this.$props.payerTypesProp
  }

  get filteredPayerTypes () {
    if (this.searchValue) {
      return this.localPayerTypes.filter((payerType: IPayerType) => (
        (payerType.payer_name && payerType.payer_name.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1) ||
        // @ts-ignore
        (payerType.payerGroup && payerType.payerGroup.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1)
      ))
    }
    return this.localPayerTypes
  }

  get payerGroup () {
    return this.$store.state.facility.facilityPayerGroups || []
  }

  get payerGroupOptions () {
    return this.payerGroup.map((item: IFacilityPayerGroup) => ({
      key: item.id,
      value: item.id,
      content: item.payerGroupName
    }))
  }

  setSelected () {
    if (this.$props.payers && this.$props.payers.length) {
      this.localPayerTypes.forEach((payer, index) => {
        const selected = this.$props.payers.findIndex((item: IPayerType) => +item === payer.id) > -1
        this.$set(this.localPayerTypes[index], 'selected', selected)
        if (!selected) {
          this.selectAll = false
        }
      })
    } else {
      this.localPayerTypes.forEach((payer, index) => {
        this.$set(this.localPayerTypes[index], 'selected', false)
        this.selectAll = false
      })
    }
  }

  toggleSelectAll (value: boolean) {
    this.localPayerTypes.forEach(payer => {
      this.changePayerSelection(payer, value)
    })
  }

  changePayerSelection (payerType: IPayerType, value: boolean) {
    // @ts-ignore
    payerType.selected = value
    if (!value) {
      this.selectAll = false
    } else {
      // @ts-ignore
      this.selectAll = this.localPayerTypes.length === this.localPayerTypes.filter(payer => payer.selected === true).length
    }
  }

  togglePayerTypeProp (payerType: IPayerType, propName: string) {
    const valueToSet = !(payerType as any)[propName];
    (payerType as any)[propName] = valueToSet
    if (!valueToSet && propName === 'prebillPrev') {
      (payerType as any)['prebillCurrent'] = valueToSet // set false
    }
    if (!valueToSet && (propName === 'prebillCurrent' || propName === 'prebillPrev')) {
      (payerType as any)['prebill'] = valueToSet // set false
    }
  }

  update () {
    // @ts-ignore
    const selectedPayers = this.localPayerTypes.filter(payer => payer.selected === true)
    this.$emit('update', selectedPayers)
  }

  mounted () {
    console.log('disableAllPayerPeriods', this.$props.disableAllPayerPeriods)
    const local = this.payerTypes.filter((payer: IPayerType) => payer.active)
    if (this.$props.payersSettings && this.$props.payersSettings.length) {
      local.forEach((pt: IPayerType, index: number) => {
        const item = this.$props.payersSettings.find((item: any) => +item.id === pt.id)
        if (item) {
          local[index] = {
            ...local[index],
            ...item
          }
        }
      })
    }
    this.localPayerTypes = local
    if (this.$props.payers && this.$props.payers.length) {
      this.localPayerTypes.forEach((payer, index) => {
        const selected = this.$props.payers.findIndex((item: IPayerType) => +item === payer.id) > -1
        this.$set(this.localPayerTypes[index], 'selected', selected)
        if (!selected) {
          this.selectAll = false
        }
      })
    } else {
      this.localPayerTypes.forEach((payer, index) => {
        this.$set(this.localPayerTypes[index], 'selected', false)
        this.selectAll = false
      })
    }
  }
}
